<template>
  <div v-if="property" class="property-header" @click="showProperty">
    <div class="property-info">
      <img
        class="property-image"
        :src="property['Images'][0]"
      >
      <span>
        {{ property['Address'] }}
      </span>
    </div>
    <span class="property-title" :style="{ color: threadColor }">
      {{ thread.subject }}
    </span>
    <detail-property-view
      v-if="showSingleRoutePropertyView && isMobile"
      class="mobile-calendar-property-view"
      :property-object-id="property._id"
    />
    <property-view-modal v-if="!isMobile" :home-info="property" :show-modal="showSingleRoutePropertyView" @close-modal="closeProperty" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getPropertyById } from '../../../services/propertiesService'
import PropertyViewModal from '../../modals/PropertyViewModal'
import DetailPropertyView from '../../search/property_view/DetailPropertyView'

export default {
  components: {
    PropertyViewModal,
    DetailPropertyView
  },
  props: {
    thread: {
      type: Object,
      default: () => ({})
    },
    threadColor: {
      type: String,
      default: 'inherit'
    }
  },
  data() {
    return {
      property: null
    }
  },
  computed: {
    ...mapState('common', ['isMobile', 'showSingleRoutePropertyView'])
  },
  watch: {
    async thread() {
      this.property = (await getPropertyById(this.thread.property_id)).data
    }
  },
  async mounted() {
    this.property = (await getPropertyById(this.thread.property_id)).data
  },
  methods: {
    ...mapMutations('common', {
      setShowSingleRoutePropertyView: 'SET_SHOW_SINGLE_ROUTE_PROPERTY_VIEW'
    }),
    closeProperty() {
      this.setShowSingleRoutePropertyView(false)
    },
    showProperty() {
      this.setShowSingleRoutePropertyView(true)
    }
  }
}
</script>

<style scoped lang="sass">
  .property-info
  .property-header
    cursor: pointer
    font-size: 14px
    display: flex
    align-items: center
    justify-content: space-between
    width: 100%
    @media only screen and (max-width: 600px)
      font-size: 12px
  .property-image
    object-fit: cover
    width: 90px
    margin-right: 20px
    height: 58px
    border-radius: 7px
    background-size: cover
  .property-title
    color: $hwayzBlue
</style>
